import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';
import { SectionImage } from 'services/api/vehicle-sections/types';

export type VideoCarouselItem = {
  id: 'exterior.video';
  url: string;
  type: 'exterior.video';
  url_thumb?: undefined;
};

export type CarouselItem = SectionImage | VideoCarouselItem;

type ViewVehicleState = {
  initialFullScreenIndex: number | null;
  fullScreenImageModalOpen: boolean;
  images: CarouselItem[];
};

const initialState: ViewVehicleState = {
  initialFullScreenIndex: null,
  fullScreenImageModalOpen: false,
  images: []
};

const viewVehicleSlice = createSlice({
  name: 'viewVehicle',
  initialState,
  reducers: {
    setImages: (state, action: PayloadAction<CarouselItem[]>) => {
      state.images = action.payload;
    },
    openFullScreenWithIndex: (state, action: PayloadAction<number>) => {
      state.fullScreenImageModalOpen = true;
      state.initialFullScreenIndex = action.payload;
    },
    openFullScreenWithId: (state, action: PayloadAction<number>) => {
      const index = state.images.findIndex(i => i.id === action.payload);
      if (index === -1) return;
      state.fullScreenImageModalOpen = true;
      state.initialFullScreenIndex = index;
    },
    closeFullScreen: (state) => {
      state.fullScreenImageModalOpen = false;
      state.initialFullScreenIndex = null;
    },
    resetState: () => {
      return initialState;
    }
  }
});

export const useOpenedFullScreenImageDialog = () =>
  useSelector<{ viewVehicle: ViewVehicleState }, boolean>(state => state.viewVehicle.fullScreenImageModalOpen);

export const useImages = () =>
  useSelector<{ viewVehicle: ViewVehicleState }, CarouselItem[]>(state => state.viewVehicle.images);

export const useInitialFullScreenIndex = () =>
  useSelector<{ viewVehicle: ViewVehicleState }, number | null>(state => state.viewVehicle.initialFullScreenIndex);

export const { setImages, openFullScreenWithId, openFullScreenWithIndex, closeFullScreen, resetState } = viewVehicleSlice.actions;
export default viewVehicleSlice;
